import { api } from '@/lib/api';

// ─── Types ──────────────────────────────────────────

export interface ABTestVariantInput {
  id: string;
  model: string;
  temperature: number;
}

export interface StartABTestResponse {
  sessionId: string;
  totalCredits: number;
  estimatedDurationSeconds: number;
}

export interface ABTestVariantResult {
  variantId: string;
  model: string;
  temperature: number;
  snapshotId: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  summary?: {
    overallScore: number;
    averages: Record<string, number>;
  };
  averageLatencyMs?: number;
  creditCost: number;
}

export interface ABTestRankingEntry {
  position: number;
  variantId: string;
  model: string;
  temperature: number;
  overallScore: number;
  averageLatencyMs: number;
  creditCost: number;
  deltaFromFirst: number;
}

export interface ABTestSessionResponse {
  sessionId: string;
  agentId: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  scenarioType: 'quick' | 'full';
  totalCredits: number;
  variants: ABTestVariantResult[];
  ranking?: ABTestRankingEntry[];
  insight?: string;
  createdAt: string;
  completedAt?: string;
}

// ─── API ────────────────────────────────────────────

export const abTestApi = {
  async start(
    agentId: string,
    variants: ABTestVariantInput[],
    scenarioType: 'quick' | 'full',
  ): Promise<StartABTestResponse> {
    const response = await api.post(`agent-training/${agentId}/ab-test`, {
      variants,
      scenarioType,
    });
    return response.data.data;
  },

  async getSession(
    agentId: string,
    sessionId: string,
  ): Promise<ABTestSessionResponse> {
    const response = await api.get(
      `agent-training/${agentId}/ab-test/${sessionId}`,
    );
    return response.data.data;
  },

  async applyVariant(
    agentId: string,
    sessionId: string,
    variantId: string,
  ): Promise<void> {
    await api.post(
      `agent-training/${agentId}/ab-test/${sessionId}/apply/${variantId}`,
    );
  },
};
